import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import RichText from '../rich-text';

export const Header = styled.h2`
  margin-top: 0;
  color: ${({ theme }) => theme.palette.standardText};
`;

export const Grid = styled.section`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.medium};

  ${({ $backgroundColor, theme }) =>
    $backgroundColor === 'grey' &&
    `
      background-color: ${theme.palette.lightBackground};
      padding-top: ${theme.spacing.medium};
      padding-bottom: ${theme.spacing.medium};
    `}

  // self target a second grid to sit flush with first
  & + & {
    margin-top: ${({ theme }) => `-${theme.spacing.medium}`};
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const Item = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  padding-bottom: ${({ theme, $border }) => $border && theme.spacing.standard};
  border-bottom: ${({ theme, $border }) => $border && theme.divider.standard};

  ${({ theme, $bulleted }) =>
    $bulleted &&
    `
    padding-left: 20px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      display: inline-block;
      left: 2px;
      top: 14px;
      width: ${theme.spacing.tiny};
      height: ${theme.spacing.tiny};
      background: ${theme.palette.standardText};
      margin-right: ${theme.spacing.small};
    }
  `};

  h3 {
    margin-top: 0;
    margin-bottom: ${({ theme }) => theme.spacing.standard};
  }

  ${breakpoint.tablet`
    width: ${({ theme }) => `calc(50% - ${theme.spacing.tiny})`};

    > *:last-child {
      margin-bottom: 0;
    }
  `}
`;

export const StyledRichText = styled(RichText)`
  > *:last-child {
    margin-bottom: 0;
  }
`;
